<template>
    <div id="leftDiv2" class="panel panel-primary panel-sp" v-if="servicePointsLoaded">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $tc("message.servicePoints", servicePointCount) }}</h3>
        </div>
        <div class="panel-body">
            <table class="table table-striped" id="tblUsageTable">
                <tbody>
                    <tr>
                        <th style="width: 10%;">{{ $t("message.type") }}</th>
                        <th style="width: 40%;" class="text-center">{{ $t("message.status") }}</th>
                        <th style="width: 40%;" class="text-center">{{ $t("message.avgDailyUsage") }}</th>
                        <th style="width: 10%;" v-if="showUsage && isDesktop" class="text-center">&nbsp;</th>
                    </tr>
                    <tr v-for="premise in servicePoints.Premises" :key="premise.Id">
                        <td class="td-alignmiddle">{{ premise.PremiseType }}</td>
                        <td class="td-alignmiddle text-center">
                            {{ premise.MeterStatus }}
                            <span v-if="premise.ShowConnectLink">
                                &nbsp;|&nbsp;&nbsp;<router-link to="/reconnect" class="lnk-connect">{{ $t("message.connect") }}</router-link>
                            </span>                            
                        </td>
                        <td class="td-alignmiddle text-center"><label>{{ premise.Usage }}</label></td>
                        <td class="td-alignmiddle text-center" v-if="isDesktop && showUsage">
                            <button class="btn-sm btn btn-primary btnViewStatement" @click.prevent="viewStatement(premise.Id)" aria-label="View Usage Statement">{{ $t("message.view") }}</button>
                        </td>
                    </tr>
                    <tr v-if="servicePoints !== ''">
                        <td><b>{{ $t("message.total") }}</b></td>
                        <td class="td-alignmiddle text-center">&nbsp;</td>
                        <td class="td-alignmiddle text-center">{{ servicePoints.TotalDailyUsageDollars }}</td>
                        <td class="td-alignmiddle text-center" v-if="isDesktop && showUsage">&nbsp;</td>
                    </tr>
                    <tr v-if="servicePoints !== '' && showUsage">
                        <td colspan="3" v-if="!isDesktop" class="text-center">
                            <button class="btn btn-primary btnViewStatementForAll" @click.prevent="viewMobileStatement()">{{ $t("message.viewStatement") }}</button>
                        </td>
                    </tr>
                    <tr v-if="servicePoints === '' && showUsage">
                        <td colspan="4"><label>{{ $t("message.noActivePremisesAvailable") }}</label></td>                        
                    </tr>
                </tbody>                
            </table>
        </div>

        <UsageStatementModal :selectedPremiseId="spId" :selectedBillingCycleAssignmentId="-1" :isUsageStatementModalVisible.sync="isModalVisible"></UsageStatementModal>
    </div>
</template>

<script>
import axios from "axios";
import UsageStatementModal from '@/components/dashboard/UsageStatementModal';

export default {
    name: 'ServicePoints',
    components: {
        UsageStatementModal
    },
    data() {
        return {
            servicePoints: '',
            isModalVisible: false,
            servicePointsLoaded: false,
            servicePointCount: 0,
            spId: -1,
            userAuthenticated: this.$store.getters.getIsAuthenticated,
            getServicePointIntervalId: ''     
        }
    },
    mounted() {
        this.getPremises();

        // Fetch Service Points information based on our homepage timer
        this.getServicePointIntervalId = window.setInterval(() => { this.getPremises(); }, this.$store.getters.getHomepageTimer);
        // Saving this off in the store so I can clear this interval from the AppLayout component
        this.$store.commit('setServicePointIntervalId', this.getServicePointIntervalId);
    },
    methods: {
        getPremises() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Home/GetPremises?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.servicePoints = response;
                    this.servicePointCount = this.servicePoints.PremiseCount;

                    this.servicePointsLoaded = true;
                }
            }, error => {
                console.log(error);
            });
        },
        viewStatement(id) {
            if (id > 0) {                
                this.spId = id;
                this.isModalVisible = true;
            }            
        },
        hideModal() {
            this.isModalVisible = false;
        },
        viewMobileStatement() {
            this.$router.push({ name: 'Usage Statement' });
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.getIsDesktop;
        },
        showUsage() {
            return this.$store.getters.getDisplayUsageReport;
        }
    },
    watch: {
        userAuthenticated(val) {
            var isAuthenticatedFromStore = this.$store.getters.getIsAuthenticated;
            this.userAuthenticated = isAuthenticatedFromStore;
            if (!isAuthenticatedFromStore) {
                window.clearInterval(this.$store.getters.getServicePointIntervalId);
                this.$store.commit('setServicePointIntervalId', '');
            }
        }
    }
}
</script>

<style scoped>
.panel-sp .td-alignmiddle {
    vertical-align: middle;
}

.lnk-connect:hover {
    color: #428BCA !important;
}
</style>
